import React from 'react';
import { connect } from 'react-redux';
import { t } from 'i18next';
import BarChart from '../../reports/barChartReport/BarChartReport';
import DataSnapshot from '../../aylaTimeZone/AylaTimeZone';
import FilterPanel, {
  date_range, dp_name, dp_value, oem_id, oem_model,
} from '../../filters/filterPanel/FilterPanel';
import LineChart from '../../reports/lineChartReport/LineChartReport';
import ReportPage from '../ReportPage';
import SingleValueDisplay from '../../reports/singleValueDisplayReport/SingleValueDisplayReport';
import TimeAggregation from '../../filters/timeAggregationFilter/TimeAggregationFilter';
import TitleBar from '../../titleBar/TitleBar';
import {AYLA_ALLOWED_ROLES, GoogleAnalyticsConstants} from '../../../constants';
import {
  activatedDevices, averageDailyTransmissions,
  datapointCountByValue, datapointCountOverTime, deviceCountByValue,
  deviceCountByValueOverTime, devicesOnlineToday, listOfDataPoints, listOfOemModels, listOfOems,
  totalDatapoints, totalTransmissions
} from '../../../services/reportsservice';
import './DatapointAnalysisPage.css';
import {logPageViewEvent} from "../../../services/analyticsservice";

class DatapointAnalysisPage extends ReportPage {
  googleAnalytics() {
    const { logged_in_oem_id } = this.props.presistFilters;
    logPageViewEvent(GoogleAnalyticsConstants.DatapointAnalysisPage.title, logged_in_oem_id);
  }
  reports() {
    const filters = this.props.presistFilters;
    return filters.dp_name ? {

      filters: [
        listOfOemModels(filters),
        listOfDataPoints(filters),
        listOfOems(filters),
      ],

      reports: [
        activatedDevices(filters),
        totalDatapoints(filters),
        devicesOnlineToday(filters),
        totalTransmissions(filters),
        averageDailyTransmissions(filters),
        datapointCountByValue(filters),
        datapointCountOverTime(filters),
        deviceCountByValue(filters),
        deviceCountByValueOverTime(filters),
      ],
    } : {
      filters: [
        listOfOemModels(filters),
        listOfDataPoints(filters),
        listOfOems(filters),
      ],
      reports: [
        activatedDevices(filters),
        totalDatapoints(filters),
      ],
    };
  }

  reportsDescription = () => [
    datapointCountByValue(),
    datapointCountOverTime(),
    deviceCountByValue(),
    deviceCountByValueOverTime(),
  ];

  render() {
    const {
      fetchData, session, presistFilters,
    } = this.props;

    const isRequired = (data) => {
      if (! presistFilters.dp_name || ! data) { return true; }
      return false;
    };

    return (
      <div className="DatapointAnalysisPage page">
        <TitleBar title="datapointAnalysis">
          <TimeAggregation value={presistFilters.aggregate_by} />
          <DataSnapshot snapShot={this.dataSnapshotTime} />
        </TitleBar>
        <div className="pageContent">
          <FilterPanel disabled={fetchData.fetches > 0}
            currentFilters={presistFilters}
            filters={[
              date_range,
              AYLA_ALLOWED_ROLES.includes(session.role) && oem_id(this.report(listOfOems)),
              oem_model(this.report(listOfOemModels)),
              dp_name(this.report(listOfDataPoints)),
              dp_value,
            ]}
          />
          <div>
            <SingleValueDisplay title="dpAnalysis.totalTransmissions"
              width={this.widthForColumns(2) + 6}
              data={this.report(totalTransmissions)}
              inputRequired={isRequired(this.report(totalTransmissions))}
              helperMsg={t('devices.datapointHelperMsg')}
            />
            <SingleValueDisplay title="dpAnalysis.averageDailyTransmissions"
              width={this.widthForColumns(2) + 6}
              data={this.report(averageDailyTransmissions)}
              inputRequired={isRequired(this.report(averageDailyTransmissions))}
              helperMsg={t('devices.datapointHelperMsg')}
            />
          </div>
          <div>
            <BarChart title="dpAnalysis.countByValue"
              width={this.widthForColumns(2)}
              height={200}
              data={this.report(datapointCountByValue)}
              description={this.reportDescription(datapointCountByValue)}
              xLabel="dpValue"
              yLabel="dpTransactions"
              skipDetailsTranslation
              inputRequired={isRequired(this.report(datapointCountByValue))}
              helperMsg={t('devices.datapointHelperMsg')}
            />
            <LineChart title="dpAnalysis.countByValueOverTime"
              width={this.widthForColumns(2)}
              height={200}
              data={this.report(datapointCountOverTime)}
              description={this.reportDescription(datapointCountOverTime)}
              xLabel={presistFilters.aggregate_by}
              yLabel="devices"
              skipDetailsTranslation
              inputRequired={isRequired(this.report(datapointCountOverTime))}
              helperMsg={t('devices.datapointHelperMsg')}
            />
          </div>
          <div>
            <BarChart title="dpAnalysis.deviceCountByValue"
              width={this.widthForColumns(2)}
              height={200}
              data={this.report(deviceCountByValue)}
              description={this.reportDescription(deviceCountByValue)}
              xLabel="dpValue"
              yLabel="devices"
              inputRequired={isRequired(this.report(deviceCountByValue))}
              helperMsg={t('devices.datapointHelperMsg')}
            />
            <LineChart title="dpAnalysis.deviceCountByValueOverTime"
              width={this.widthForColumns(2)}
              height={200}
              data={this.report(deviceCountByValueOverTime)}
              description={this.reportDescription(deviceCountByValueOverTime)}
              xLabel={presistFilters.aggregate_by}
              yLabel="devices"
              skipDetailsTranslation
              inputRequired={isRequired(this.report(deviceCountByValueOverTime))}
              helperMsg={t('devices.datapointHelperMsg')}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(DatapointAnalysisPage);
